import { VerticalListViewImpl } from '../verticallistview';
import { PaginationVerticalListComponentProps } from './paginationverticallistcomponent';
import { UIComponentState } from '../../uicomponent';
import { PaginationVerticalListCSSStyle } from './paginationverticallistcss';
import * as React from 'react';
import { PaginationComponent } from '../../pagination/paginationcomponent';
import { PaginationListViewModel } from './paginationlistviewmodel';

export class PaginationVerticalListViewImpl<T> extends VerticalListViewImpl<T>
{
    private paginationRef: PaginationComponent<T> | null;

    draw(props: PaginationVerticalListComponentProps<T>, state: UIComponentState, cssStyle: PaginationVerticalListCSSStyle): JSX.Element | boolean
    {
        // super.draw(props, state, cssStyle);
        return(
            <>
            <table style={cssStyle.getWrapperCSSStyle()}>
               {
                   props.listViewModel.getHeader()
               } 
              <tbody style={{width: "100%", height: "100%", display: "flex", flexFlow: "row wrap"}}>
                {
                    props.listViewModel.getListOfDatas().map((entry, index)=>
                    {
                        return props.listViewModel.getView(entry, index);
                    }
                )
                }
              </tbody>
            </table>
           
            <div style={cssStyle.getPaginationCSSStyle()}>
                <PaginationComponent ref={(item:any) => {this.paginationRef=item;}} onPageSelected={props.onLoadMore} listViewModel={(props.listViewModel as PaginationListViewModel<T>)} context={props.context}/>
                
            </div>
            
            </>
       );
    }

    updatePaginationCount()
    {
        this.paginationRef !== null && this.paginationRef.updatePaginationCount();
    }

    resetPaginationCount()
    {
        this.paginationRef !== null && this.paginationRef.resetPaginationCount();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/paginationverticallist/paginationverticallistview.tsx